// extracted by mini-css-extract-plugin
module.exports = {"container_ellipsis":"commons_container_ellipsis__2XWEH","label_highlight":"commons_label_highlight__2vTLY"};